<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('sponsors.Header') }}</h2>
                <br />
                {{ $t('sponsors.Text') }}
                <br />
                <br />
                <br />
                <center>
                    <table border="0">
                        <tr>
                            <td><a href="https://www.scholler-immobilien.de/index.html" target="_blank"><img src="../images/sponsors/schollerimmobilien.jpg" width="250" /></a></td>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td><a href="https://www.scholler-immobilien.de/index.html" style="text-decoration:none;" target="_blank"><strong>{{ $t('sponsors.Scholler') }}</strong></a></td>
                        </tr>
                    </table>
                </center>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>